import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { ToolDetailPage } from './pages/ToolDetailPage';
import { FavoritesPage } from './pages/FavoritesPage';
import { AdminLoginPage } from './pages/AdminLoginPage';
import { AdminDashboardPage } from './pages/AdminDashboardPage';
import { DonationSuccessPage } from './pages/DonationSuccessPage';
import { DonationErrorPage } from './pages/DonationErrorPage';
import { SubscriptionCheckerPage } from './pages/SubscriptionCheckerPage';
import { AIBotPoliticsPage } from './pages/AIBotPoliticsPage';
import { FavoritesProvider } from './contexts/FavoritesContext';
function App() {
  return <FavoritesProvider data-id="element-0">
      <Router data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
          <Route path="/favorites" element={<FavoritesPage data-id="element-6" />} data-id="element-5" />
          <Route path="/subscriptions" element={<SubscriptionCheckerPage data-id="element-8" />} data-id="element-7" />

          {/* Donation pages */}
          <Route path="/donation/success" element={<DonationSuccessPage data-id="element-10" />} data-id="element-9" />
          <Route path="/donation/error" element={<DonationErrorPage data-id="element-12" />} data-id="element-11" />

          {/* Admin routes */}
          <Route path="/admin" element={<Navigate to="/admin/login" replace data-id="element-14" />} data-id="element-13" />
          <Route path="/admin/login" element={<AdminLoginPage data-id="element-16" />} data-id="element-15" />
          <Route path="/admin/dashboard" element={<AdminDashboardPage data-id="element-18" />} data-id="element-17" />

          {/* Privacy policy - accessible only via URL */}
          <Route path="/aibotpolitics" element={<AIBotPoliticsPage data-id="element-20" />} data-id="element-19" />

          {/* Tool detail page - must be last to avoid conflicts */}
          <Route path="/:toolName" element={<ToolDetailPage data-id="element-22" />} data-id="element-21" />
        </Routes>
      </Router>
    </FavoritesProvider>;
}
export { App };